module.exports = __webpack_public_path__ + "img/FR10160.da43f461.png";